import React, {Component} from 'react';
import {connect} from 'react-redux';
import {AvailablePlayersList} from './available-players-list';
import PlayersCollectionInterface from 'interfaces/players-data-interfaces/players-collection-interface';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';

interface Props {
    playerToBeSwapped: PlayerInterface;
    games: object;
    playersFilter: object;
    players: PlayersCollectionInterface;
    lineup: LineupInterface;
    maxTotalSalary: number;
    sportConfig: object;
}

class AvailablePlayers extends Component<Props> {
    render() {
        const {playerToBeSwapped, games, playersFilter, lineup, maxTotalSalary, sportConfig, players} = this.props;

        if (!lineup) {
            return null;
        }

        const lineupPlayerIds = lineup.players.map((player) => player.getId());
        const substitutePlayers = players.getSwapOptions(
            playerToBeSwapped,
            games,
            lineupPlayerIds,
            playersFilter,
            sportConfig,
        );

        return (
            <AvailablePlayersList
                substitutePlayers={substitutePlayers}
                substitutablePlayer={playerToBeSwapped}
                lineup={lineup}
                maxTotalSalary={maxTotalSalary}
                currentTotalSalary={lineup.totalSalary}
                sportConfig={sportConfig}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {games, filters: playersFilter, players},
        salaryCap,
    } = state;

    return {
        players,
        games,
        playersFilter,
        maxTotalSalary: salaryCap.getInnerMax(),
    };
}

export default connect(mapStatesToProps)(AvailablePlayers);
